const STANDARD_FACEBOOK_EVENTS = new Set([
    'AddPaymentInfo',
    'AddToCart',
    'InitiateCheckout',
    'Purchase',
    'ViewCart',
    'ViewContent',
])

const GA4_EVENT_NAMES = {
    AddPaymentInfo: 'add_payment_info',
    AddToCart: 'add_to_cart',
    AuthStart: 'auth_start',
    AuthSuccess: 'auth_success',
    CheckoutButtonClick: 'checkout_button_click',
    InitiateCheckout: 'begin_checkout',
    PaymentFailed: 'payment_failed',
    Purchase: 'purchase',
    PurchaseCourier: 'purchase_courier',
    RegStart: 'reg_start',
    RegSuccess: 'reg_success',
    Search: 'search',
    ViewCart: 'view_cart',
    ViewContent: 'view_item',
    ViewThanksPage: 'view_thanks_page',
}

function removeEmptyParams(params) {
    return Object.fromEntries(
        Object.entries(params).filter(([, value]) => {
            if (Array.isArray(value)) {
                return value.length > 0
            }

            return value !== undefined && value !== null && value !== ''
        }),
    )
}

function toGa4Items(contents = []) {
    return contents.map((item) => removeEmptyParams({
        item_id: item.id,
        item_name: item.title,
        quantity: item.quantity,
        price: item.item_price,
    }))
}

function buildGa4Params(title, data = {}) {
    const customData = data.custom_data || {}

    return removeEmptyParams({
        event_id: data.event_id,
        event_label: title,
        currency: customData.currency,
        value: customData.value,
        items: toGa4Items(customData.contents || []),
        transaction_id: customData.order_id,
        payment_type: customData.payment_method,
        payment_provider: customData.payment_provider,
        checkout_stage: customData.stage,
        content_type: customData.content_type,
        content_ids: customData.content_ids,
        restaurant_id: customData.restaurant_id,
        restaurant_title: customData.restaurant_title,
        failure_reason: customData.reason,
        search_term: customData.search_term,
        result_count: customData.result_count,
        source: customData.source,
    })
}

export default class Event {
    constructor(val) {
        this.that = val
    }

    send(title, data={}) {

        //console.log('sendEvent', title, data)

        // facebook
        try{
            const fbParams = {
                event_name: (data && data.event_name) ? data.event_name : null,
                event_id:   (data && data.event_id) ? data.event_id : null,
                action_source: 'website',
                event_time: (data && data.event_time) ? data.event_time : Math.floor(Date.now() / 1000),
                user_data: {
                    external_id: (data && data.user_data && data.user_data.external_id ) ? data.user_data.external_id : null,
                    fbc: (data && data.user_data && data.user_data.fbc) ? data.user_data.fbc : null,
                    fbp: (data && data.user_data && data.user_data.fbp) ? data.user_data.fbp : null,
                    client_user_agent: (data && data.user_data && data.user_data.client_user_agent) ? data.user_data.client_user_agent : null,
                    subscription_id: (data && data.user_data && data.user_data.subscription_id) ? data.user_data.subscription_id : null,
                    // client_ip_address: (data && data.client_ip_address) ? data.client_ip_address : null,
                },
                // custom_data держим отдельным объектом, чтобы переиспользовать один payload builder.
                custom_data: (data && data.custom_data) ? data.custom_data : null,
                event_source_url: (data.event_source_url) ? data.event_source_url : window.location.href,
            }
            if(window.fbq) {
                if (STANDARD_FACEBOOK_EVENTS.has(title)) {
                    window.fbq('track', title, fbParams.custom_data || {}, {
                        eventID: fbParams.event_id,
                    })
                } else {
                    window.fbq('trackCustom', title, fbParams)
                }
            }
            
        } catch (e) {
            console.log('fbq error', e)
        }

        // GTM
        try{
            if(this.that.$gtm) {
                this.that.$gtm.trackEvent({
                    event: title,
                    category: 'event',
                    action: 'action',
                    label: title,
                    value: 1,
                    noninteraction: false, // Optional
                })
            }
        } catch (e) {
            // console.log('GTM error', e)
        }

        // Google Analytics 4
        try{
            if(this.that.$gtag) {
                const eventName = GA4_EVENT_NAMES[title] || title
                this.that.$gtag.event(eventName, buildGa4Params(title, data))
            }
        } catch (e) {
            console.log('gtag error', e)
        }

        //yandex
        try{
            if(this.that.$yandexMetrika){
                this.that.$yandexMetrika.reachGoal(title)
            }
        } catch (e) {
            console.log('yandexMetrika error', e)
        }

        return
    }

}